import React, { useEffect, useState } from "react";
import GoogleSheetsAPI from "./GoogleSheetAPI";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

const defaultValues = {
  name: "--",
  brand: "--",
  category: "--",
  asin: "--",
  BSR: "--",
  EstimatedSales: "--",
  SalePrice: "--",
  CostPrice: "--",
  Profit: "--",
  ROI: "--",
  TotalFees: "--",
};

const LOCAL_STORAGE_FIELD_KEYS = 'sheetFields';

const GoogleSheets = ({ data, salesData, spreadsheetId, setSpreadsheetId }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [fieldData, setFieldData] = useState(null);
  const [defaultFieldsData, setDefaultFieldData] = useState(defaultValues);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const storedFieldKeys = localStorage.getItem(LOCAL_STORAGE_FIELD_KEYS);

    if (data && salesData) {
      const updatedValues = {
        name: data?.basicInfo?.productName || "--",
        brand: data?.basicInfo?.brand || "--",
        category: data?.basicInfo?.category || "--",
        asin: data?.asin || "--",
        BSR: data?.overview?.BSR?.BSR || "--",
        EstimatedSales: salesData?.sales_estimation?.monthly_sales || "--",
        SalePrice: data?.overview?.prices?.sale_price || "--",
        CostPrice: data?.overview?.prices?.cost_price || "--",
        Profit: "$" + Number(data?.overview?.profit) || "--",
        ROI: data?.overview?.roi ?? "--",
        TotalFees:
          "$" + Number(data?.profitCalculator?.total_fees?.total) || "--",
      };
      setDefaultFieldData(updatedValues);
       if (!storedFieldKeys) {
        setFieldData(updatedValues);
       }
    }
  }, [data, salesData]);

  useEffect(() => {
    const storedFieldKeys = localStorage.getItem(LOCAL_STORAGE_FIELD_KEYS);

    if (storedFieldKeys) {
      try {
        const keys = JSON.parse(storedFieldKeys);

        const initialFieldData = {};

        keys.forEach((key) => {
          if (defaultFieldsData.hasOwnProperty(key)) {
            initialFieldData[key] =
              fieldData?.[key] ?? defaultFieldsData[key] ?? "";
          }
        });
        setFieldData(initialFieldData);
      } catch (error) {
        console.error("Failed to parse stored field keys", error);
        setFieldData(defaultFieldsData);
      }
    } else {
      setFieldData(defaultFieldsData);
      localStorage.setItem(
        LOCAL_STORAGE_FIELD_KEYS,
        JSON.stringify(Object.keys(defaultFieldsData))
      );
    }
  }, [defaultFieldsData]);
  // Utility function to convert JSON to CSV with proper escaping
  const convertToCSV = (jsonData) => {
    const array = [Object.keys(jsonData[0])].concat(jsonData);

    return array
      .map((row) => {
        return Object.values(row)
          .map((value) => {
            if (typeof value === "string") {
              // Escape double quotes and wrap the value in double quotes
              value = value.replace(/"/g, '""');
              return `"${value}"`;
            }
            return value;
          })
          .join(",");
      })
      .join("\n");
  };

  return (
    <div
      className="flex flex-col w-full text-white"
    >
      <div className="">
        <div
          className="flex cursor-pointer items-center mb-4 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary text-md font-bold"
          >
            Google Sheets
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
        </div>
        {isOpen && (
          <>
            <GoogleSheetsAPI
              spreadsheetId={spreadsheetId}
              setSpreadsheetId={setSpreadsheetId}
              fieldData={fieldData}
              setFieldData={setFieldData}
              defaultFieldsData={defaultFieldsData}
            />
            <div></div>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleSheets;
